import EquityBanner from './EquityBanner';
import EquitySection from './EquitySection';

function Equity() {
  return (
    <div>
      <EquityBanner />
      <EquitySection />
    </div>
  );
}

export default Equity;